import { render, staticRenderFns } from "./copy-video.vue?vue&type=template&id=ebfe926a&scoped=true&"
import script from "./copy-video.vue?vue&type=script&lang=js&"
export * from "./copy-video.vue?vue&type=script&lang=js&"
import style0 from "./copy-video.vue?vue&type=style&index=0&id=ebfe926a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfe926a",
  null
  
)

export default component.exports